import {createContext} from 'react';

export const ServerConfigContext = createContext();
